import { useTranslation } from "react-i18next";
import styled from "styled-components";
import { buttonColorNew } from "../../../utils/palette";
import { components } from "react-select";

const MultiValueOption = (props) => {
  const { t } = useTranslation("common");
  let label = "";

  if (props?.selectProps?.customProps?.type === "serviceTask") {
    label = t("create_new_service_task");
  }
  if (props?.selectProps?.customProps?.type === "expenseTask") {
    label = t("create_new_expense_task");
  }
  if (props?.selectProps?.customProps?.type === "inspectionTask") {
    label = t("create_new_inspection_task");
  }
  if (props?.selectProps?.customProps?.type === "issue") {
    label = t("create_new_issue");
  }

  //console.log(props.data);
  if (props.data.__isNew__) {
    return (
      <>
        <hr style={{ margin: 0, padding: 0 }} />
        <components.Option {...props}>
          <span
            style={{ color: buttonColorNew, fontWeight: 300, fontSize: "12px" }}
          >
            {label}
            <span style={{ fontWeight: 500 }}> "{props.data.value}"</span>
          </span>
        </components.Option>
      </>
    );
  }
  return (
    <components.Option {...props}>
      {/* <InputRadioContainer>
            <CheckboxInput
              name={props.value}
              type="checkbox"
              checked={props.isSelected}
              onChange={() => null}
              style={{ width: "auto" }}
              //defaultValue={false}
            />
            <Label>{props.label}</Label>
          </InputRadioContainer> */}
      <div
        className="d-flex align-items-center"
        style={{ height: "18px" }}
        {...props}
      >
        <TaskCheckboxInput
          id="task"
          name={props.value}
          type="checkbox"
          checked={props.isSelected}
          onChange={() => null}
        />
        <TaskLabel htmlFor="task" onClick={(e) => e.preventDefault()}>
          {props.label}
        </TaskLabel>
      </div>
    </components.Option>
  );
};

export default MultiValueOption;

//styles

const TaskLabel = styled.label`
  //font-size: 14px;
  margin: 0;
`;

const TaskCheckboxInput = styled.input`
  width: auto !important;
  margin-right: 8px;
  //margin-top: -1px;
  position: relative;
  //top: 2px;
`;
